import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_DELETE } from '../../../constants/api';
import { removeWarehousePart } from '../../../actions/coilovers/warehouse/patchWarehouse';

const deleteWarehouse = createAsyncThunk('warehouse/deleteWarehouse',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      await authSet(METHOD_DELETE, `/co/warehouse/${id}`);
      dispatch(removeWarehousePart(id));
      return id;
    } catch (error) {
      return rejectWithValue(error.message || 'Something went wrong');
    }
  });

export default deleteWarehouse;
